export enum enumSubscriptionType {
  BASIC = 0,
  STARTER = 1,
  GROWTH = 2,
  ENTERPRISE = 3,
}
